import { EnvironmentType } from '@environment/enums';
import { initSentry, initSentryEvents } from '@shared/sentry';
import { Services } from '../services';

const PRODUCTION_BACKEND_URL = 'https://ntfsups23eodzpas42fyviox3e0drihb.lambda-url.us-east-1.on.aws/';

export async function initializeServiceWorker(services: Services): Promise<void> {
  if (services.environment.type === EnvironmentType.Development) {
    if (!services.environment.backendUrlDev) {
      throw new Error('BACKEND_URL_DEV not set in .env for local development');
    }
    await services.commonStore.setBackendUrl(services.environment.backendUrlDev);
  } else if (services.environment.type === EnvironmentType.Production) {
    await services.commonStore.setBackendUrl(PRODUCTION_BACKEND_URL);
  } else {
    throw new Error(`Unknown environment type: ${services.environment.type}`);
  }

  initSentry(
    services.environment.enableSentry && !!services.environment.sentryAuthToken,
    services.environment,
    true,
    false
  );
  initSentryEvents(services.environment);

  services.analyticsService.enabled = services.environment.enableAnalytics && !!services.environment.mixpanelToken;
  if (services.analyticsService.enabled) {
    services.analyticsService.initialize(services.environment.mixpanelToken, services.environment.npmPackageVersion);
  }
}
